import { useQuery } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { MobileToken } from '../types';

export const getMobileToken = ({ groupId }: { groupId: string }): Promise<MobileToken> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'mobile-token/check/' + groupId;

  return axios
    .get(endPoint, {
      validateStatus: (status) => status < 500,
    })
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }

      if (response?.status === 404) {
        return {
          groupId: groupId,
        };
      }

      return response;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};

type QueryFnType = typeof getMobileToken;

type UseMobileTokenOptions = {
  groupId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useMobileToken = ({ groupId, config }: UseMobileTokenOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getMobileToken({ groupId }),
    ...config,
  });
};
